module.exports = __webpack_public_path__ + "static/media/addVideo.729db24e.svg";